import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTrash,
    faEdit,
    faArrowUp,
    faArrowDown,
    faSync,
    faEye,
    faBoxOpen,
    faTableCellsLarge,
} from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import '../adminTables.css';
import './ProductosData.css';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import baseURL from '../../url';
import apiFetch from '../../apiFetch';
import NewProduct from '../NewProduct/NewProduct';
import ImportarProductos from '../ImportarProductos/ImportarProductos';
import { Link as Anchor } from "react-router-dom";

export default function ProductosData() {
    const [productos, setProductos] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [nuevoTitulo, setNuevoTitulo] = useState('');
    const [nuevaDescripcion, setNuevaDescripcion] = useState('');
    const [nuevoPrecioAnterior, setNuevoPrecioAnterior] = useState(0);
    const [nuevoPrecio, setNuevoPrecio] = useState('');
    const [nuevoPrecioMinimo, setNuevoPrecioMinimo] = useState('');
    const [nuevoPrecioMaximo, setNuevoPrecioMaximo] = useState('');
    const [nuevoCosto, setNuevoCosto] = useState('');
    const [nuevoStock, setNuevoStock] = useState('');
    const [nuevoStockMinimo, setNuevoStockMinimo] = useState('');
    const [nuevoStockMaximo, setNuevoStockMaximo] = useState('');
    const [nuevaCategoria, setNuevaCategoria] = useState('');
    const [producto, setProducto] = useState({});
    const [modalImagenVisible, setModalImagenVisible] = useState(false);
    const [imagenSeleccionada, setImagenSeleccionada] = useState('');
    const [filtroId, setFiltroId] = useState('');
    const [filtroTitulo, setFiltroTitulo] = useState('');
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [filtroMasVendido, setFiltroMasVendido] = useState('');
    const [ordenInvertido, setOrdenInvertido] = useState(false);
    const [imagenPreview, setImagenPreview] = useState(null);
    const [nuevaImagen, setNuevaImagen] = useState(null);
    const [selectedSection, setSelectedSection] = useState('texto');
    const [categorias, setCategoras] = useState([]);

    const cerrarModalImagen = () => {
        setModalImagenVisible(false);
    };

    const abrirModalImagenSeleccionada = (imagen) => {
        setImagenSeleccionada(imagen);
        setModalImagenVisible(true);
    };


    useEffect(() => {
        cargarProductos();

    }, []);

    useEffect(() => {
        // Actualiza el valor del select cuando cambia el estado nuevoEstado
        setNuevoTitulo(producto.titulo);
        setNuevaDescripcion(producto.descripcion);
        setNuevaCategoria(producto.idCategoria)
        setNuevoPrecioAnterior(producto.precioAnterior)
        setNuevoPrecio(producto.precio ?? '');
        setNuevoPrecioMinimo(producto.precioMinimo ?? '');
        setNuevoPrecioMaximo(producto.precioMaximo ?? '');
        setNuevoCosto(producto.costo ?? '');
        setNuevoStock(producto.stock ?? '');
        setNuevoStockMinimo(producto.stockMinimo ?? '');
        setNuevoStockMaximo(producto.stockMaximo ?? '');
    }, [producto]);

    const cargarProductos = () => {
        apiFetch(`${baseURL}/productos/productosGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setProductos(data.productos || []);
            })
            .catch(error => console.error('Error al cargar productos:', error));
    };

    const eliminarProducto = (idProducto) => {
        // Reemplaza el window.confirm con SweetAlert2
        Swal.fire({
            title: '¿Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                apiFetch(`${baseURL}/productos/productDelete.php?idProducto=${idProducto}`, {
                    method: 'DELETE',
                })
                    .then(response => response.json())
                    .then(data => {
                        Swal.fire(
                            '¡Eliminado!',
                            data.mensaje,
                            'success'
                        );
                        cargarProductos();
                    })
                    .catch(error => {
                        console.error('Error al eliminar la Producto:', error);
                        toast.error(error);
                    });
            }
        });
    };

    const abrirModal = (item) => {
        setProducto(item);
        setNuevoTitulo(item.titulo);
        setNuevaDescripcion(item.descripcion);
        setNuevaCategoria(item.idCategoria);
        setModalVisible(true);
    };

    const cerrarModal = () => {
        setModalVisible(false);
    };

    const productosFiltrados = productos.filter(item => {
        const idMatch = item.idProducto.toString().includes(filtroId);
        const tituloMatch = !filtroTitulo || item.titulo.includes(filtroTitulo);
        const categoriaMatch = !filtroCategoria || item.idCategoria.toString() === filtroCategoria;
        const masVendidoMatch = !filtroMasVendido || String(item.masVendido || '').includes(filtroMasVendido);
        return idMatch && tituloMatch && categoriaMatch && masVendidoMatch;
    });

    const descargarExcel = () => {
        const data = productosFiltrados.map(item => ({
            IdProducto: item.idProducto,
            Titulo: item.titulo,
            Descripcion: item.descripcion,
            Precio: item.precio,
            Fecha: item.createdAt,
            MasVendido: item.masVendido,
            Imagen1: item.imagen1,
            Imagen2: item.imagen2,
            Imagen3: item.imagen3,
            Imagen4: item.imagen4,

        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Productos');
        XLSX.writeFile(wb, 'productos.xlsx');
    };

    const descargarPDF = () => {
        const pdf = new jsPDF();
        pdf.text('Lista de Productos', 10, 10);

        const columns = [
            { title: 'IdProducto', dataKey: 'idProducto' },
            { title: 'Titulo', dataKey: 'titulo' },
            { title: 'Descripcion', dataKey: 'descripcion' },
            { title: 'Precio', dataKey: 'precio' },
            { title: 'MasVendido', dataKey: 'masVendido' },
            { title: 'Fecha', dataKey: 'createdAt' },
        ];

        const data = productosFiltrados.map(item => ({
            IdProducto: item.idProducto,
            Titulo: item.titulo,
            Descripcion: item.descripcion,
            Precio: item.precio,
            MasVendido: item.masVendido,
            Fecha: item.createdAt,

        }));

        pdf.autoTable({
            head: [columns.map(col => col.title)],
            body: data.map(item => Object.values(item)),
        });

        pdf.save('productos.pdf');
    };

    const invertirOrden = () => {
        setProductos([...productos].reverse());
        setOrdenInvertido(!ordenInvertido);
    };


    const handleUpdateText = (idProducto) => {
        const payload = {

            nuevoTitulo: nuevoTitulo !== '' ? nuevoTitulo : producto.titulo,
            nuevaDescripcion: nuevaDescripcion !== undefined ? nuevaDescripcion : producto.descripcion,
            nuevoPrecio: nuevoPrecio !== '' ? nuevoPrecio : producto.precio,
            nuevoPrecioMinimo: nuevoPrecioMinimo !== '' ? nuevoPrecioMinimo : producto.precioMinimo,
            nuevoPrecioMaximo: nuevoPrecioMaximo !== '' ? nuevoPrecioMaximo : producto.precioMaximo,
            nuevoCosto: nuevoCosto !== '' ? nuevoCosto : producto.costo,
            nuevoStock: nuevoStock !== '' ? nuevoStock : producto.stock,
            nuevoStockMinimo: nuevoStockMinimo !== '' ? nuevoStockMinimo : producto.stockMinimo,
            nuevoStockMaximo: nuevoStockMaximo !== '' ? nuevoStockMaximo : producto.stockMaximo,
            nuevaCategoria: nuevaCategoria !== '' ? nuevaCategoria : producto.idCategoria,
            item1: producto.item1,
            item2: producto.item2,
            item3: producto.item3,
            item4: producto.item4,
            item5: producto.item5,
            item6: producto.item6,
            item7: producto.item7,
            item8: producto.item8,
            item9: producto.item9,
            item10: producto.item10,
            precioAnterior: nuevoPrecioAnterior !== 0 ? nuevoPrecioAnterior : producto.precioAnterior,
        };

        apiFetch(`${baseURL}/productos/productoTextPut.php?idProducto=${idProducto}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        })
            .then(response => response.json())
            .then(data => {
                if (data.error) {

                    Swal.fire(
                        'Error!',
                        data.error,
                        'error'
                    );
                } else {

                    Swal.fire(
                        'Editado!',
                        data.mensaje,
                        'success'
                    );
                    cargarProductos();
                    cerrarModal()
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    };

    const handleFileChange = (event, setFile, setPreview) => {
        const file = event.target.files[0];

        if (file) {
            // Crear una URL de objeto para la imagen seleccionada
            const previewURL = URL.createObjectURL(file);
            setFile(file);
            setPreview(previewURL);
        }
    };
    const handleEditarImagenBanner = (idProducto) => {
        const formData = new FormData();
        formData.append('idProducto', idProducto);
        formData.append('updateAction', 'update'); // Campo adicional para indicar que es una actualización

        if (nuevaImagen) {
            formData.append('imagen1', nuevaImagen);
        }

        apiFetch(`${baseURL}/productos/productoImagePut.php`, {
            method: 'POST',  // Cambiado a POST
            body: formData
        })
            .then(response => {
                // Manejar el caso cuando la respuesta no es un JSON válido o está vacía
                if (!response.ok) {
                    throw new Error('La solicitud no fue exitosa');

                }

                return response.json();
            })
            .then(data => {
                if (data.error) {

                    toast.error(data.error);
                } else {

                    toast.success(data.mensaje);
                    cargarProductos();
                    setNuevaImagen(null);
                    setImagenPreview(null);
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
    };

    const handleSectionChange = (section) => {
        setSelectedSection(section);
    };

    useEffect(() => {
        cargarCategoria();
    }, []);


    const cargarCategoria = () => {
        apiFetch(`${baseURL}/categorias/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    return (
        <section className='productosAdmin'>
            <ToastContainer />

            <NewProduct onCreated={cargarProductos} />

            <div className='productosAdmin__header'>
                <div>
                    <span className='productosAdmin__badge'>
                        <FontAwesomeIcon icon={faBoxOpen} />
                        Gestión de catálogo
                    </span>
                    <h1>Productos</h1>
                    <p>Gestiona productos, categorías, imágenes y contenido del catálogo.</p>
                </div>

                <div className='productosAdmin__actions'>
                    <ImportarProductos categorias={categorias} onImported={cargarProductos} />
                    <button className='excel' onClick={descargarExcel}><FontAwesomeIcon icon={faArrowDown} /> Excel</button>
                    <button className='pdf' onClick={descargarPDF}><FontAwesomeIcon icon={faArrowDown} /> PDF</button>
                    <button className='reload' onClick={() => window.location.reload()}><FontAwesomeIcon icon={faSync} /> Recargar</button>
                </div>
            </div>

            <div className='productosAdmin__topbar'>
                <div className='statCard'>
                    <span>Total productos</span>
                    <strong>{productos.length}</strong>
                </div>

                <div className='statCard'>
                    <span>Resultados filtrados</span>
                    <strong>{productosFiltrados.length}</strong>
                </div>

                <div className='statCard'>
                    <span>Categorías disponibles</span>
                    <strong>{categorias.length}</strong>
                </div>
            </div>

            <div className='filtrosContain'>
                <div className='inputsColumn'>
                    <label>ID</label>
                    <input type="number" value={filtroId} onChange={(e) => setFiltroId(e.target.value)} placeholder='Id Producto' />
                </div>

                <div className='inputsColumn'>
                    <label>Título</label>
                    <input type="text" value={filtroTitulo} onChange={(e) => setFiltroTitulo(e.target.value)} placeholder='Título' />
                </div>

                <div className='inputsColumn'>
                    <label>Categoría</label>
                    <select value={filtroCategoria} onChange={(e) => setFiltroCategoria(e.target.value)}>
                        <option value="">Categorias</option>
                        {
                            categorias.map(item => (
                                <option key={item?.idCategoria} value={item?.idCategoria}>{item?.categoria}</option>
                            ))
                        }
                    </select>
                </div>

                <div className='inputsColumn'>
                    <label>Más vendido</label>
                    <select value={filtroMasVendido} onChange={(e) => setFiltroMasVendido(e.target.value)}>
                        <option value="">Más vendidos</option>
                        <option value="si">Si</option>
                        <option value="no">No</option>
                    </select>
                </div>

                <button className='reverse' onClick={invertirOrden}>
                    {ordenInvertido ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />} Orden
                </button>
            </div>

            {modalImagenVisible && (
                <div className="modalImg">
                    <div className="modal-contentImg">


                        <span className="close2" onClick={cerrarModalImagen}>
                            &times;
                        </span>

                        <img src={imagenSeleccionada} alt="Imagen Seleccionada" />
                    </div>
                </div>
            )}

            {modalVisible && (
                <div className="modal">
                    <div className="modal-content modalEditarProducto">
                        <div className='deFlexBtnsModal'>

                            <div className='deFlexBtnsModal'>
                                <button
                                    className={selectedSection === 'texto' ? 'selected' : ''}
                                    type='button'
                                    onClick={() => handleSectionChange('texto')}
                                >
                                    Editar Texto
                                </button>
                                <button
                                    className={selectedSection === 'imagenes' ? 'selected' : ''}
                                    type='button'
                                    onClick={() => handleSectionChange('imagenes')}
                                >
                                    Editar Imagenes
                                </button>
                            </div>
                            <span className="close" onClick={cerrarModal}>
                                &times;
                            </span>
                        </div>
                        <div className='sectiontext' style={{ display: selectedSection === 'texto' ? 'flex' : 'none' }}>
                            <div className='flexGrap'>
                                <fieldset className='fieldsetTitulo'>
                                    <legend>Titulo</legend>
                                    <input
                                        type="text"
                                        value={nuevoTitulo !== '' ? nuevoTitulo : producto.titulo}
                                        onChange={(e) => setNuevoTitulo(e.target.value)}
                                        autoComplete='off'
                                        autoCorrect='off'
                                        autoCapitalize='off'
                                        spellCheck='false'
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Categoria</legend>
                                    <select
                                        value={nuevaCategoria !== '' ? nuevaCategoria : producto.idCategoria}
                                        onChange={(e) => setNuevaCategoria(e.target.value)}
                                    >
                                        <option value=''>Selecciona una categoría</option>
                                        {
                                            categorias.map(item => (
                                                <option key={item?.idCategoria} value={item?.idCategoria}>{item?.categoria}</option>
                                            ))
                                        }
                                    </select>
                                </fieldset>

                                <fieldset id='descripcion'>
                                    <legend>Descripcion</legend>
                                    <textarea
                                        type="text"
                                        value={nuevaDescripcion}
                                        onChange={(e) => setNuevaDescripcion(e.target.value)}
                                        autoComplete='off'
                                        autoCorrect='off'
                                        autoCapitalize='off'
                                        spellCheck='false'
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecioAnterior !== '' ? nuevoPrecioAnterior : producto.precioAnterior}
                                        onChange={(e) => setNuevoPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecio}
                                        onChange={(e) => setNuevoPrecio(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio mínimo (rango vendedor)</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecioMinimo}
                                        onChange={(e) => setNuevoPrecioMinimo(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio máximo (rango vendedor)</legend>
                                    <input
                                        type="number"
                                        value={nuevoPrecioMaximo}
                                        onChange={(e) => setNuevoPrecioMaximo(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Costo</legend>
                                    <input
                                        type="number"
                                        value={nuevoCosto}
                                        onChange={(e) => setNuevoCosto(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Stock (cantidad en mano)</legend>
                                    <input
                                        type="number"
                                        value={nuevoStock}
                                        onChange={(e) => setNuevoStock(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Stock mínimo</legend>
                                    <input
                                        type="number"
                                        value={nuevoStockMinimo}
                                        onChange={(e) => setNuevoStockMinimo(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Stock máximo</legend>
                                    <input
                                        type="number"
                                        value={nuevoStockMaximo}
                                        onChange={(e) => setNuevoStockMaximo(e.target.value)}
                                    />
                                </fieldset>
                            </div>




                            <button className='btnPost' onClick={() => handleUpdateText(producto.idProducto)} >Guardar </button>

                        </div>

                        <div className='sectionImg' style={{ display: selectedSection === 'imagenes' ? 'flex' : 'none' }}>
                            <div className='previevProduct'>

                                {imagenPreview ? (
                                    <img src={imagenPreview} alt="Vista previa de la imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen1)} />
                                ) : (
                                    <>
                                        {producto.imagen1 ? (
                                            <img src={producto.imagen1} alt="imagen" onClick={() => abrirModalImagenSeleccionada(producto.imagen1)} />

                                        ) : (
                                            <span className='imgNone'>
                                                No hay imagen

                                            </span>
                                        )}
                                    </>
                                )}
                            </div>
                            <fieldset>
                                <legend>Editar Imagen1 </legend>
                                <input type="file" accept="image/*" onChange={(e) => handleFileChange(e, setNuevaImagen, setImagenPreview)} />
                            </fieldset>


                            <button className='btnPost' onClick={() => handleEditarImagenBanner(producto.idProducto)}>Guardar </button>

                        </div>



                    </div>
                </div>
            )}

            <div className='adminTableCard'>
                <div className='adminTableCard__header'>
                    <h3><FontAwesomeIcon icon={faTableCellsLarge} /> Tabla de productos</h3>
                    <p>Puedes editar, eliminar o previsualizar cada producto.</p>
                </div>

                <div className='table-responsive'>
                    <table className='modernTable'>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Producto</th>
                                <th>Categoría</th>
                                <th>Stock</th>
                                <th className='align-right'>Acciones</th>
                            </tr>
                        </thead>

                        <tbody>
                            {productosFiltrados.length === 0 ? (
                                <tr>
                                    <td colSpan='5' className='tableState'>No hay productos para mostrar.</td>
                                </tr>
                            ) : productosFiltrados.map(item => {
                                // Se resuelve acá y no con un filter+map que renderiza celdas:
                                // si la categoría ya no existe, la fila se desalineaba.
                                const categoria = categorias.find(c => c.idCategoria === item.idCategoria);

                                return (
                                    <tr key={item.idProducto}>
                                        <td>
                                            <span className='idBadge'>#{item.idProducto}</span>
                                        </td>

                                        <td>
                                            <div className='cellWithIcon'>
                                                {item.imagen1 ? (
                                                    <img
                                                        className='cellThumb'
                                                        src={item.imagen1}
                                                        alt={item.titulo}
                                                        onClick={() => abrirModalImagenSeleccionada(item.imagen1)}
                                                    />
                                                ) : (
                                                    <span className='cellThumb cellThumb--empty'>
                                                        <FontAwesomeIcon icon={faBoxOpen} />
                                                    </span>
                                                )}

                                                <div>
                                                    <strong>{item.titulo}</strong>
                                                    <span>{item.imagen1 ? 'Con imagen' : 'Sin imagen'}</span>
                                                </div>
                                            </div>
                                        </td>

                                        <td>{categoria ? categoria.categoria : 'Sin categoría'}</td>

                                        <td>
                                            {/* El stock baja solo cuando la cajera factura el pedido. */}
                                            {item.stock === null || item.stock === '' || item.stock === undefined ? (
                                                <span className='stockBadge stockBadge--sinControl'>Sin control</span>
                                            ) : (
                                                <span
                                                    className={`stockBadge ${Number(item.stock) <= 0
                                                        ? 'stockBadge--agotado'
                                                        : Number(item.stock) <= Number(item.stockMinimo || 0)
                                                            ? 'stockBadge--bajo'
                                                            : ''}`}
                                                >
                                                    {item.stock}
                                                </span>
                                            )}
                                        </td>

                                        <td className='align-right'>
                                            <div className='tableActions'>
                                                <Anchor
                                                    className='tableBtn tableBtn--view'
                                                    to={`/producto/${item?.idProducto}/${item?.titulo?.replace(/\s+/g, '-')}`}
                                                    title='Ver producto'
                                                >
                                                    <FontAwesomeIcon icon={faEye} />
                                                </Anchor>

                                                <button className='tableBtn tableBtn--edit' type='button' onClick={() => abrirModal(item)} title='Editar producto'>
                                                    <FontAwesomeIcon icon={faEdit} />
                                                </button>

                                                <button className='tableBtn tableBtn--delete' type='button' onClick={() => eliminarProducto(item.idProducto)} title='Eliminar producto'>
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </section>
    );
};
